import { Component, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';

@Component({
  selector: 'email-tellent-grow-logo',
  styleUrls: ['./email-tellent-grow-logo.component.less'],
  template: `
    <a href="https://tellent.com/" target="_blank">
      <img
        class="grow-logo"
        [src]="'assets/logo-grow.png'"
        [width]="120"
        [height]="50"
        alt="Tellent Grow"
      />
    </a>
  `,
  imports: [EmailImageAssetDirective],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class EmailTellentGrowLogoComponent {}
